import { setOptions } from '@googlemaps/js-api-loader'

const options = {
	key: 'AIzaSyAAa2JtezAnWENSSyBfh0Rovv3jeN5E-tg',
	v: 'weekly',
}

export default function importGoogleMapsLibrary(name) {
	// Multiple bundles may initialize maps on the same page.
	if (!window.google?.maps?.importLibrary) {
		setOptions(options)
	}

	return window.google.maps.importLibrary(name)
}
